"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * ImageCell - Composant image responsive
 * La navigation interne est gérée par le CellWrapper parent
 */const ImageCell = ({
  image_uri,
  alt = '',
  styles_properties = {},
  className = '',
  style = {},
  link_to,
  objectFit = 'cover',
  action_log,
  onLoad,
  onError,
  uri_transformer = url => url,
  ...rest
}) => {
  // Styles du conteneur
  const containerStyle = {
    backgroundColor: styles_properties.background_color,
    borderRadius: styles_properties.border_radius ? `${styles_properties.border_radius}px` : undefined,
    borderColor: styles_properties.border_color,
    borderWidth: styles_properties.border_width ? `${styles_properties.border_width}px` : undefined,
    borderStyle: styles_properties.border_style,
    padding: styles_properties.padding ? `${styles_properties.padding}px` : undefined,
    opacity: styles_properties.opacity,
    width: '100%',
    height: '100%',
    ...style
  };
  const handleLoad = e => {
    if (onLoad) onLoad(e);
  };
  const handleError = e => {
    if (onError) onError(e);
  };
  const isClickable = !!link_to;
  const containerClasses = ['image-cell', isClickable && 'image-cell--clickable', className].filter(Boolean).join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: containerClasses,
    style: {
      ...containerStyle,
      cursor: isClickable ? 'pointer' : 'default'
    },
    "data-action-log": action_log,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      className: "image-cell__image",
      src: uri_transformer(image_uri),
      alt: alt,
      onLoad: handleLoad,
      onError: handleError,
      style: {
        objectFit: styles_properties?.objectFit || objectFit,
        width: '100%',
        height: '100%'
      },
      loading: "lazy"
    })
  });
};
var _default = exports.default = ImageCell;